import React, { useState, useEffect, useContext } from 'react'
import Axios from 'axios'
import { Modal, Spinner, Tab, Tabs } from 'react-bootstrap'
import { BsXCircle } from 'react-icons/bs'
import SurvayItem from '../components/SurvayItem'
import 'react-input-range/lib/css/index.css'
import endpoints from '../js/endpoints'
import StringHelper from '../helper/StringHelper'
import RateContext from '../contexts/RateContext'
import InputRange from 'react-input-range'
import TripContext from '../contexts/TripContext'
import toast from 'toast-me'
import ModalHeader from 'react-bootstrap/esm/ModalHeader'

export default function SurvayModal(props) {
  let tripContext = useContext(TripContext)

  useEffect(() => {
    getRatingItems()
    setRateAvalable(tripContext.trip.finished === 1 && tripContext.trip.DriverScore === 0)
    if (tripContext.trip.DriverScore > 0)
      setSliderValue(tripContext.trip.DriverScore)
    setDesc(tripContext.trip.feedbackText)
  }, [])

  const [rateAvalable, setRateAvalable] = useState(false)
  const [badItems, setBadItems] = useState([])
  const [goodItems, setGoodItems] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [sliderValue, setSliderValue] = useState(5)
  const [desc, setDesc] = useState('')

  const [isWaiting, setIsWaiting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)


  let closeModal = () => {
    props.onChange()
  }

  let getRatingItems = () => {
    setIsLoading(true)
    console.log(tripContext.trip)
    Axios({
      url: endpoints.GetRatingItems,
      method: 'get',
      params: {
        refNum: tripContext.trip.tripCode

      }
    })
      .then((res) => {
        let bads = []
        let goods = []
        res.data.result.map((o, i) => {
          if (o.rType === 1) {
            bads.push(o)
          } else if (o.rType === 2) {
            goods.push(o)
          }
        })
        setBadItems(bads)
        setGoodItems(goods)
        setIsLoading(false)
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  let registerPoll = () => {
    setIsWaiting(true)
    var items = []
    selectedItems.map((o, i) => {
      items.push(o.rId)
    })
    var rates = items.join(',')

    Axios({
      url: endpoints.AddRating,
      method: 'post',
      params: {
        refNum: tripContext.trip.serviceCode,
        rate: sliderValue,
        ratingItems: rates,
        feedbackText: desc
      },
    })
      .then((res) => {
        setIsWaiting(false)
        closeModal()
        toast('پیام شما با موفقیت ثبت شد', {
          duration: 3000,
          toastClass: 'text-white text-right bg-success',
        })
        window.location.reload()
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  let addToSelectedItems = (item) => {
    selectedItems.push(item)
  }

  let removeFromSelectedItems = (item) => {
    setSelectedItems(selectedItems.filter((i) => item.rId !== i.rId))
  }

  let handleChange = (e) => {

    try {
      let name = e.target.name
      let value = e.target.value

      if (!rateAvalable)
        value = desc
      setDesc(value)
      console.log(value)
    } catch (e) {
      console.log(e)
    }

  }

  return (
    <RateContext.Provider
      value={{
        items: selectedItems,
        addRate: addToSelectedItems,
        removeRate: removeFromSelectedItems,
      }}
    >
      <Modal show={props.show} onHide={closeModal}>
        <div className="container-fluid d-flex flex-column justify-content-center p-0">
          <ModalHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
            <h4><strong>امتیاز دهی</strong></h4>
            <button className="btn btn-dnager rounded-circle text-white" onClick={closeModal}>
              <BsXCircle size="2em" />
            </button>
          </ModalHeader>
          <div className="w-100 p-3 my-4" style={{ direction: 'ltr' }}>
            <InputRange
              draggableTrack
              maxValue={10}
              minValue={1}
              value={sliderValue}

              onChange={(value) => (rateAvalable ? setSliderValue(value) : sliderValue)}
            />
          </div>
          {isLoading ? (
            <div className="d-flex justify-content-center w-100">
              <Spinner animation="border" />
            </div>
          ) : (
            <Tabs defaultActiveKey="positive" id="uncontrolled-tab-example">
              <Tab eventKey="positive" title="نقاط قوت">
                <div className="grid-container">
                  {goodItems.map((o, i) => (
                    <div className="d-flex justify-content-center align-items-center m-2 w100">
                      <SurvayItem key={i} obj={o} selected={o.isActive === 1} disabled={rateAvalable} />
                    </div>
                  ))}
                </div>
              </Tab>
              <Tab eventKey="negative" title="نقاط ضعف">
                <div className="grid-container">
                  {badItems.map((o, i) => (
                    <div className="d-flex justify-content-center align-items-center m-2 w100">
                      <SurvayItem key={i * 10} obj={o} selected={o.isActive === 1} disabled={rateAvalable} />
                    </div>
                  ))}
                </div>
              </Tab>
            </Tabs>
          )}

          <div className="w-100 p-2">
            <h6 className="text-right mt-2">انتقادات و پیشنهادات:</h6>
            <textarea
              className="form-control mb-3"
              id="exampleFormControlTextarea1"
              rows="5"
              placeholder="توضیحات"
              onChange={handleChange}
              value={desc}
            />
          </div>
          {
            rateAvalable ?
              <button
                className="btn btn-success d-flex justify-content-center align-items-center m-2 block"
                disabled={isWaiting}
                onClick={registerPoll}
              >
                {isWaiting ? <Spinner animation="border" size="sm" /> : 'ثبت نظر'}
              </button>
              : null
          }
        </div>
      </Modal>
    </RateContext.Provider>
  )
}
